import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class AuthApi extends YoApi {
	async login ({ username, password, token }) {
		return this.create({ username, password, token });
	}

	async logOut () {
		const { data } = await this.axios.delete(this.getUrl());
		return data;
	}

	async beginSSO() {
		window.location.href = this.getUrl('sso')
	}
}

export default new AuthApi({
	endPoint: 'auth'
});
